import React, { useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ModalComp } from "../ModalComp";
import { AutomationZones } from "./AutomationZones";
import { Alert } from "../Alert";
import Cookies from "js-cookie";
import { EditAutomation, automationWidgetList } from "../../api";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
const AutomationEdit = (props) => {
  const { titleEdit, iconEdit, uid } = props;
  const [automationId, setAutomationId] = useState(uid);
  console.log(automationId);
  const { t } = useTranslation();
  const token = Cookies.get("token");
  const [title, setTitle] = useState(titleEdit);
  const [icon, setIcon] = useState(iconEdit || "icon-muic");
  const [automationCommand, setAutomationCommand] = useState([]);
  const handleTitle = (e) => {
    setTitle(e.target.value);
  };
  const [widgetIndex, setWidgetIndex] = useState("");

  const icons = [
    "icon-slepp",
    "icon-muic",
    "icon-in",
    "icon-out",
    "icon-sun",
    "icon-tvv",
  ];
  const handleEditAutomation = () => {
    const data = new FormData();
    data.append("title", title);
    data.append("icon", icon);
    data.append("automation_id", automationId);

    EditAutomation(data, token)
      .then((result) => console.log(result))
      .catch((error) => console.error(error));
  };
  const [x, setX] = useState([]);
  useEffect(() => {
    console.log(automationCommand);
    const data = new FormData();
    data.append("automation_id", automationId);
    automationWidgetList(data, token)
      .then((result) => {
        setAutomationCommand(result.data.data);
      })
      .catch((error) => console.error(error));
  }, [automationId]);
  const handleEditEvents = () => {
    setOpenAutomationZoneModal(true);
  };
  const [isOpen, setIsOpen] = useState(false);
  //   const [icon, setIcon] = useState(icon || "icon-muic");
  const handleIcon = (i) => {
    // setIcon(i);
  };
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  const widgetClicked = (value, index) => {
    setWidgetIndex(index);
  };
  const handleClose = (i) => {
    const cllose = automationCommand.filter((index) => index.caption !== i);
    setAutomationCommand(cllose);
  };
  const [openAutomationZoneModal, setOpenAutomationZoneModal] = useState(false);
  const toggleAutomationZone = () => {
    setOpenAutomationZoneModal(!openAutomationZoneModal);
  };
  return (
    <>
      <ModalComp
        modal={openAutomationZoneModal}
        toggle={toggleAutomationZone}
        component={
          <AutomationZones
            title={title}
            icon={icon}
            setAutomationCommand={setAutomationCommand}
            automationId={automationId}
          />
        }
      />

      <div className="m-auto d-flex justify-content-between align-items-center py-4 px-3">
        <div className="text-right">
          <p className="m-0 fn12">
            نام اتوماسیون و آیکون دلخواه خود را انتخاب نمایید
          </p>
        </div>
      </div>
      <div className=" addScenarioCard bg-white  mb-3 mt-3 d-flex text-right justify-content-between align-items-center px-3 py-2">
        <input
          className="inputStyle"
          type="text"
          placeholder="اضافه کردن اتوماسیون..."
          onChange={handleTitle}
          value={title}
        ></input>
        <Dropdown isOpen={isOpen} toggle={toggleDropdown}>
          <DropdownToggle
            className="addScenarioIcon border-0 text-center rounded-circle d-flex flex-column"
            style={{ backgroundColor: "#007bff", color: "#fff" }}
          >
            {icon && (
              <i
                className={icon}
                style={{ color: "#fff", margin: "auto", fontSize: "20px" }}
              />
            )}
          </DropdownToggle>
          <DropdownMenu>
            {icons.map((icon, index) => (
              <DropdownItem key={icon} onClick={() => handleIcon(icon)}>
                <i key={index} className={icon} />
              </DropdownItem>
            ))}
          </DropdownMenu>
        </Dropdown>
      </div>
      <div className="scroll ">
        {console.log(automationCommand)}
        {automationCommand.length ? (
          <div>
            <small> {t("رویدادهای انتخاب شده:")}</small>
          </div>
        ) : (
          "no"
        )}
        <div>
          {automationCommand?.map((item, index) => {
            let active = widgetIndex === index ? "selectZonesActive" : "";
            const widgetId = item;

            return (
              <div>
                <div
                  onClick={() => widgetClicked(item, index)}
                  key={index}
                  className={`selectWidget 
           text-center py-2 my-2 cursor ${active}`}
                >
                  <div className="d-flex border-bottom-4 justify-content-between px-2">
                    <label className=" ">
                      {item.caption}
                      {" : "}
                      {item.command === "10" ? t("روشن") : t("خاموش")}
                    </label>
                    <button
                      className="btn-close "
                      onClick={() => {
                        handleClose(item.caption);
                      }}
                    ></button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "60vh" }}
      >
        <div
          className="mx-3 d-flex justify-content-center align-items-center flex-column text-center"
          onClick={handleEditEvents}
        >
          <span className="profileAddUser bg-white d-block cursor">+</span>
          <small className="fn12 mt-1">{t("رویداد")}</small>
        </div>

        <div
          className="mx-3 d-flex justify-content-center align-items-center flex-column text-center"
          onClick={handleEditAutomation}
        >
          <span className="profileAddUser bg-white d-block icon-ok cursor"></span>
          <small className="fn12 mt-1">{t("ثبت")}</small>
        </div>
      </div>
      {/* {showAlert.show && (
        <Alert
          message={showAlert.message}
          type={showAlert.type}
          title={title}
          icon={icon}
          question={showAlert.question}
          request={showAlert.request}
          toggleAlert={toggleAlert}
          setOpenAddAutomationModal={setOpenAddAutomationModal}
        />
      )} */}
    </>
  );
};
export { AutomationEdit };
